/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs */

const en_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niches, products and stores, plus what good output looks like.`)
};

const ar_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخصصات والمنتجات والمتاجر، إضافة إلى شكل الناتج الجيد.`)
};

const bn_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিশ, পণ্য আর স্টোর, সাথে ভালো ফলাফল কেমন দেখায়।`)
};

const de_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nischen, Produkte und Shops, plus wie gute Ergebnisse aussehen.`)
};

const es_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichos, productos y tiendas, más cómo se ve un buen resultado.`)
};

const fr_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niches, produits et boutiques, plus à quoi ressemble un bon résultat.`)
};

const pt_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichos, produtos e lojas, mais como é um bom resultado.`)
};

const zh_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确赛道、产品和店铺，以及好结果长什么样。`)
};

const tr_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nişler, ürünler ve mağazalar, artı iyi çıktının neye benzediği.`)
};

const ru_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ниши, товары и магазины, плюс как выглядит хороший результат.`)
};

const pl_svc_ai_image_pod_automation_scope_detail5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nisze, produkty i sklepy, plus jak wygląda dobry wynik.`)
};

/**
* | output |
* | --- |
* | "Niches, products and stores, plus what good output looks like." |
*
* @param {Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_scope_detail5 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_scope_detail5(inputs)
	return en_svc_ai_image_pod_automation_scope_detail5(inputs)
});
export { svc_ai_image_pod_automation_scope_detail5 as "svc_ai-image-pod-automation_SCOPE_detail" }